import { AnimationTransform, AnimationOpacity, AnimationAction, IdtAnimation, AnimationParallax, AnimationScroll } from './animations.model';


export function isTransformAnimation(animation: AnimationAction): animation is AnimationTransform {
  return animation.actionType === 'transform';
}

export function isOpacityAnimation(animation: AnimationAction): animation is AnimationOpacity {
  return animation.actionType === 'opacity';
}

export function isActionAnimation(animation: IdtAnimation): animation is AnimationAction {
  return 'action' in animation;
}

export function isActionParallax(animation: IdtAnimation): animation is AnimationParallax {
  return 'parallax' in animation;
}

export function isActionScroll(animation: IdtAnimation): animation is AnimationScroll {
  return 'scroll' in animation;
}
